import { render, staticRenderFns } from "./ExchangeRateModal.vue?vue&type=template&id=23f7d311&scoped=true"
import script from "./ExchangeRateModal.vue?vue&type=script&lang=js"
export * from "./ExchangeRateModal.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRateModal.vue?vue&type=style&index=0&id=23f7d311&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f7d311",
  null
  
)

export default component.exports